import { render, staticRenderFns } from "./PetmedByClinicTable.vue?vue&type=template&id=18ea960e&scoped=true&"
import script from "./PetmedByClinicTable.vue?vue&type=script&lang=js&"
export * from "./PetmedByClinicTable.vue?vue&type=script&lang=js&"
import style0 from "./PetmedByClinicTable.vue?vue&type=style&index=0&id=18ea960e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ea960e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
